/**
 * PDP Media Slide Counter
 * Updates "current / total" overlay as the gallery slide changes.
 */
(function () {
  'use strict';

  function getVisibleMediaItems(carousel) {
    return Array.from(carousel.querySelectorAll('.product__media-item:not(.is-filtered)'));
  }

  async function updateSlideCounter(productMedia) {
    var carousel = productMedia.querySelector('flickity-carousel');
    var counter = productMedia.querySelector('.product__slide-counter');

    if (!carousel || !counter) {
      return;
    }

    var currentEl = counter.querySelector('.product__slide-current');
    var totalEl = counter.querySelector('.product__slide-total');

    if (!currentEl || !totalEl) {
      return;
    }

    var visibleItems = getVisibleMediaItems(carousel);
    var total = visibleItems.length;
    var current = 1;

    if (carousel.flickityInstance) {
      try {
        var flickity = await carousel.flickityInstance;

        if (flickity && flickity.slides) {
          total = flickity.slides.length;
        }

        if (flickity && flickity.selectedIndex >= 0) {
          current = flickity.selectedIndex + 1;
        }
      } catch (error) {
        /* flickity not ready yet — fall back to DOM selection below */
      }
    }

    if (current === 1 && total > 1) {
      var selected = carousel.querySelector('.product__media-item.is-selected:not(.is-filtered)') ||
        carousel.querySelector('.product__media-item.is-initial-selected:not(.is-filtered)');

      if (selected) {
        var selectedIndex = visibleItems.indexOf(selected);

        if (selectedIndex >= 0) {
          current = selectedIndex + 1;
        }
      }
    }

    currentEl.textContent = String(current);
    totalEl.textContent = String(total);
    counter.hidden = total <= 1;
  }

  function bindProductMedia(productMedia) {
    var carousel = productMedia.querySelector('flickity-carousel');

    if (!carousel || carousel.hasAttribute('data-slide-counter-bound')) {
      return;
    }

    carousel.setAttribute('data-slide-counter-bound', '');

    ['flickity:ready', 'flickity:slide-changed', 'flickity:slide-settled'].forEach(function (eventName) {
      carousel.addEventListener(eventName, function () {
        updateSlideCounter(productMedia);
      });
    });

    var formId = productMedia.getAttribute('form-id');

    if (formId) {
      var form = document.getElementById(formId);

      if (form) {
        form.addEventListener('variant:changed', function () {
          // Reload is async; wait for Flickity to rebuild before recounting.
          window.setTimeout(function () {
            updateSlideCounter(productMedia);
          }, 50);
        });
      }
    }

    updateSlideCounter(productMedia);
  }

  function init() {
    document.querySelectorAll('product-media').forEach(bindProductMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
